import { OperationalDestinationBanner } from '../../../design-system/components/operational-destination-message/OperationalDestinationBanner';
import { Popin } from '../../../design-system/components/popin/Popin';
import { Destination } from '../../../resources/destination/domain/types/destination';
import { OperationalMessage } from '../../../resources/destination/domain/types/operationalMessage';
import { md5 } from '../../utilities/crypto/md5';
import { PickDomain } from '../../utilities/types/PickDomain';

type OperationalMessageProp = PickDomain<
    OperationalMessage,
    'type' | 'title' | 'message',
    {
        pillLabel: string | null;
        ctaLabel: string | null;
        ctaUrl: string | null;
    }
>;

type Props = {
    destinationSlug: Destination['slug'];
    messages: OperationalMessageProp[];
    closeLabel: string;
};

function buildStorageKey(destinationSlug: string, message: OperationalMessageProp): string {
    const fingerprint = md5(`${message.type}:${message.title}:${message.message}`);

    return `operational-message-dismissed:${destinationSlug}:${fingerprint}`;
}

export function OperationalMessages({ destinationSlug, messages, closeLabel }: Props) {
    return (
        <>
            {messages.map((message) => {
                const storageKey = buildStorageKey(destinationSlug, message);

                if (message.type === 'closed') {
                    return (
                        <OperationalDestinationBanner
                            key={storageKey}
                            title={message.title}
                            message={message.message}
                            pillLabel={message.pillLabel}
                            ctaLabel={message.ctaLabel}
                            ctaUrl={message.ctaUrl}
                        />
                    );
                }

                return (
                    <Popin
                        key={storageKey}
                        variant={message.type}
                        title={message.title}
                        message={message.message}
                        closeLabel={closeLabel}
                        pillLabel={message.pillLabel}
                        ctaLabel={message.ctaLabel}
                        ctaUrl={message.ctaUrl}
                        storageKey={storageKey}
                    />
                );
            })}
        </>
    );
}
